import React from "react";
import { Box, Modal, useMediaQuery, useTheme } from "@mui/material";
import { InnerModalContent } from "./InnerModalContent";

interface ServiceInquiryModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedService?: string;
}

const ServiceInquiryModal: React.FC<ServiceInquiryModalProps> = ({
  isOpen,
  onClose,
  selectedService,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Modal open={isOpen} onClose={onClose} aria-labelledby="service-inquiry-modal">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isMobile ? "92vw" : "min(92vw, 920px)",
          maxHeight: "92vh",
          overflowY: "auto",
          borderRadius: "18px",
          p: isMobile ? 1 : 1.3,
          background: "rgba(255,240,235,0.78)",
          border: "1px solid rgba(255,255,255,0.54)",
          boxShadow: "0 24px 60px rgba(0,0,0,0.26)",
          backdropFilter: "blur(8px)",
          outline: "none",
        }}
      >
        <InnerModalContent
          onClose={onClose}
          selectedService={selectedService || ""}
        />
      </Box>
    </Modal>
  );
};

export default ServiceInquiryModal;
